import { render, staticRenderFns } from "./directly_order_report.vue?vue&type=template&id=2ff29772"
import script from "./directly_order_report.vue?vue&type=script&lang=js"
export * from "./directly_order_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ff29772')) {
      api.createRecord('2ff29772', component.options)
    } else {
      api.reload('2ff29772', component.options)
    }
    module.hot.accept("./directly_order_report.vue?vue&type=template&id=2ff29772", function () {
      api.rerender('2ff29772', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/order_manage/directly_order_report/directly_order_report.vue"
export default component.exports